import { render, staticRenderFns } from "./DrugsUsageByMonthRep.vue?vue&type=template&id=53ef32e9&"
import script from "./DrugsUsageByMonthRep.vue?vue&type=script&lang=js&"
export * from "./DrugsUsageByMonthRep.vue?vue&type=script&lang=js&"
import style0 from "./DrugsUsageByMonthRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports